import { Component } from '@angular/core';
import {NgClass, NgIf} from "@angular/common";
import {ToastrService} from "ngx-toastr";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {AuthenticationHttpService} from "../../../../services/http-services/authentication/authentication-http.service";
import {
  FormControlErrorMessagesModule
} from "../../../../pipes/form-control-error-messages/form-control-error-messages.module";
import {confirmMatchControlsValidator} from "../../../../validators/form-validators.validator";
import {SpinnerComponent} from "../../../../shared-components/spinner/spinner.component";
import {ProfileHttpService} from "../../../../services/http-services/profile/profile-http.service";
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'tl-change-password',
  standalone: true,
  imports: [
    NgIf,
    ReactiveFormsModule,
    FormControlErrorMessagesModule,
    NgClass,
    SpinnerComponent,
    TranslateModule
  ],
  templateUrl: './change-password.component.html',
})
export class ChangePasswordComponent {
  formTriedToSubmit = false;
  isCurrentPasswordShow = false;
  isNewPasswordShow = false;
  isConfirmPasswordShow = false;
  isSpinnerActive = false;
  changePasswordForm!: FormGroup
  constructor(private formBuilder: FormBuilder,
              private router: Router,
              private toastService: ToastrService,
              private profileHttpService: ProfileHttpService) { }

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm(): void {
    this.changePasswordForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(8)]],
      new_password: ['', [Validators.required, Validators.minLength(8)]],
      password_confirmation: ['', [Validators.required, Validators.minLength(8)]],
    }, {
      validators: confirmMatchControlsValidator('new_password', 'password_confirmation')
    });
  }

  onSubmitChangePasswordForm(): void {
    this.formTriedToSubmit = true;
    if (this.changePasswordForm.valid) {
      this.isSpinnerActive = true;
      this.profileHttpService.changeProfilePassword(this.changePasswordForm.value).then((res: any) => {
        this.isSpinnerActive = false;
        this.toastService.success(res.message);
      }).catch(error => {
        this.isSpinnerActive = false;
        if (error.error.code === 403) {
          this.toastService.error();
        } else {
          Object.values(error.error.data).forEach((value: any) => this.toastService.error());
        }
      });
    }
  }
}
